// 监管合同路由

export default {
  path: '/park/superviseContract',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'list',
      name: 'list',
      component: () => import('@/pages/superviseContract/SuperviseContractList/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管合同列表',
      },
    },
    {
      path: 'detail',
      name: 'detail',
      component: () => import('@/pages/superviseContract/SuperviseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管合同维护',
      },
    },
    {
      path: 'closeContract',
      name: 'closeContract',
      component: () => import('@/pages/superviseContract/SuperviseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管合同关闭',
      },
    },
    {
      path: 'agreement',
      name: 'agreement',
      component: () => import('@/pages/superviseContract/SuperviseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '补充协议',
      },
    },
    {
      path: 'approval',
      name: 'approval',
      component: () => import('@/pages/superviseContract/SuperviseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管合同审批',
      },
    },
    {
      path: 'renew',
      name: 'renew',
      component: () => import('@/pages/superviseContract/SuperviseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管合同续签',
      },
    },
    {
      path: 'change',
      name: 'change',
      component: () => import('@/pages/superviseContract/SuperviseContractDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '监管合同信息变更',
      },
    },
  ],
};
